// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-page {
    padding: 2rem;
    margin-left: 250px;
    margin-top: 70px;
    width: calc(100% - 250px);
    box-sizing: border-box;
}

.users-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 2rem;
}

.title-section h1 {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.header-icon {
    color: #4a90e2;
}

.actions {
    display: flex;
    gap: 1rem;
}

.search-bar {
    display: flex;
    align-items: center;
    width: 300px;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    background-color: white;
}

.search-icon {
    color: #6b7280;
    margin-right: 0.5rem;
    font-size: 1rem;
}

.search-input {
    flex: 1 1;
    border: none;
    outline: none;
    font-size: 0.875rem;
}

.filter-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.9rem;
    position: relative;
}

.badge-filter {
    position: absolute;
    top: -8px;
    right: -8px;
    background-color: #dc3545;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.users-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.user-card {
    background: white;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
}

.user-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.user-card-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.user-avatar {
    width: 48px;
    height: 48px;
    background-color: #4a90e2;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 600;
}

.user-name {
    flex: 1 1;
}

.user-name h3 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
}

.user-id {
    font-size: 0.8rem;
    color: #666;
}

.user-card-body {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #444;
    font-size: 0.9rem;
}

.user-info svg {
    color: #666;
    font-size: 1rem;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
}

.modal-content h2 {
    margin-bottom: 1.5rem;
    color: #333;
}

.filter-options {
    margin-bottom: 2rem;
}

.filter-section {
    margin-bottom: 1.5rem;
}

.filter-section h3 {
    font-size: 1rem;
    color: #444;
    margin-bottom: 0.75rem;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
}

/* User Details Modal */
.user-details {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.detail-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
}

.detail-section h3 {
    color: #333;
    margin-bottom: 1rem;
    font-size: 1.1rem;
}

.detail-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
}

.detail-item {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.detail-item.full-width {
    grid-column: 1 / -1;
}

.detail-item label {
    font-size: 0.85rem;
    color: #666;
}

.detail-item p {
    margin: 0;
    color: #333;
    font-size: 0.95rem;
    word-break: break-all;
}

/* Button Styles */
.btn {
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    transition: background-color 0.2s;
}

.btn.primary {
    background-color: #4a90e2;
    color: white;
}

.btn.secondary {
    background-color: #e9ecef;
    color: #333;
}

.btn.danger {
    background-color: #dc3545;
    color: white;
}

.btn:hover {
    opacity: 0.9;
}

/* Loading and Empty States */
.loading-spinner {
    text-align: center;
    padding: 2rem;
    color: #666;
}

.no-users {
    text-align: center;
    padding: 2rem;
    color: #666;
    background: #f8f9fa;
    border-radius: 8px;
}

/* Pagination */
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 2rem;
}

.pagination button {
    padding: 0.5rem 1rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: white;
    cursor: pointer;
}

.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination span {
    color: #666;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yCAAyC;IACzC,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".users-page {\n    padding: 2rem;\n    margin-left: 250px;\n    margin-top: 70px;\n    width: calc(100% - 250px);\n    box-sizing: border-box;\n}\n\n.users-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 2rem;\n}\n\n.title-section h1 {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n}\n\n.header-icon {\n    color: #4a90e2;\n}\n\n.actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.search-bar {\n    display: flex;\n    align-items: center;\n    width: 300px;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    padding: 0.5rem 1rem;\n    background-color: white;\n}\n\n.search-icon {\n    color: #6b7280;\n    margin-right: 0.5rem;\n    font-size: 1rem;\n}\n\n.search-input {\n    flex: 1;\n    border: none;\n    outline: none;\n    font-size: 0.875rem;\n}\n\n.filter-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    background-color: white;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    position: relative;\n}\n\n.badge-filter {\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    background-color: #dc3545;\n    color: white;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n}\n\n.users-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.user-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: transform 0.2s, box-shadow 0.2s;\n    cursor: pointer;\n}\n\n.user-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.user-card-header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.user-avatar {\n    width: 48px;\n    height: 48px;\n    background-color: #4a90e2;\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n\n.user-name {\n    flex: 1;\n}\n\n.user-name h3 {\n    margin: 0;\n    font-size: 1.1rem;\n    font-weight: 600;\n}\n\n.user-id {\n    font-size: 0.8rem;\n    color: #666;\n}\n\n.user-card-body {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.user-info {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: #444;\n    font-size: 0.9rem;\n}\n\n.user-info svg {\n    color: #666;\n    font-size: 1rem;\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 12px;\n    padding: 2rem;\n    width: 90%;\n    max-width: 800px;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.modal-content h2 {\n    margin-bottom: 1.5rem;\n    color: #333;\n}\n\n.filter-options {\n    margin-bottom: 2rem;\n}\n\n.filter-section {\n    margin-bottom: 1.5rem;\n}\n\n.filter-section h3 {\n    font-size: 1rem;\n    color: #444;\n    margin-bottom: 0.75rem;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n/* User Details Modal */\n.user-details {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n}\n\n.detail-section {\n    background: #f8f9fa;\n    border-radius: 8px;\n    padding: 1.5rem;\n}\n\n.detail-section h3 {\n    color: #333;\n    margin-bottom: 1rem;\n    font-size: 1.1rem;\n}\n\n.detail-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1rem;\n}\n\n.detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.detail-item.full-width {\n    grid-column: 1 / -1;\n}\n\n.detail-item label {\n    font-size: 0.85rem;\n    color: #666;\n}\n\n.detail-item p {\n    margin: 0;\n    color: #333;\n    font-size: 0.95rem;\n    word-break: break-all;\n}\n\n/* Button Styles */\n.btn {\n    padding: 0.75rem 1.5rem;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n\n.btn.primary {\n    background-color: #4a90e2;\n    color: white;\n}\n\n.btn.secondary {\n    background-color: #e9ecef;\n    color: #333;\n}\n\n.btn.danger {\n    background-color: #dc3545;\n    color: white;\n}\n\n.btn:hover {\n    opacity: 0.9;\n}\n\n/* Loading and Empty States */\n.loading-spinner {\n    text-align: center;\n    padding: 2rem;\n    color: #666;\n}\n\n.no-users {\n    text-align: center;\n    padding: 2rem;\n    color: #666;\n    background: #f8f9fa;\n    border-radius: 8px;\n}\n\n/* Pagination */\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n.pagination button {\n    padding: 0.5rem 1rem;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    background: white;\n    cursor: pointer;\n}\n\n.pagination button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.pagination span {\n    color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
